import React from "react";
import { Tabs } from "antd";

import SaveSearchReport from "./SaveSearchReport";
import TagsReport from "./TagsReport";

const MyViewReport = () => {
  const items = [
    {
      key: "1",
      label: "My Tags",
      children: <TagsReport />,
    },
    {
      key: "2",
      label: "Saved Searches",
      children: <SaveSearchReport />,
    },
  ];

  return (
    <section id="dashboard">
      <div className="container-fluid">
        <Tabs className="mx-0" defaultActiveKey="1" items={items} />
      </div>
    </section>
  );
};

export default MyViewReport;
